<template>
    <div class="text-center">
        <online-booking-calendar-single
            v-if="rentalProperty"
            :calendar-id="singleBookingCalendarID"
            :rental-property-id="rentalProperty.id"
            :rental-property-name="rentalProperty.name"
            :website-url="website.url"
        />
        <online-booking-calendar-multi
            v-else
            :area-id="areaID"
            :calendar-id="multiBookingCalendarID"
            :website-url="website.url"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import OnlineBookingCalendarMulti from './online-booking-calendar-multi.vue';
    import OnlineBookingCalendarSingle from './online-booking-calendar-single.vue';

    export default {
        name: 'OnlineBookingCalendar',
        components: {
            OnlineBookingCalendarMulti,
            OnlineBookingCalendarSingle,
        },
        computed: {
            ...mapGetters('onlineBooking', ['rentalProperty', 'website']),
            areaID() {
                return this.$route.params.areaId || 0;
            },
            websiteUrl() {
                return this.website.url;
            },
        },
        data() {
            return {
                singleBookingCalendarID: 'lx-online-booking-calendar-single',
                multiBookingCalendarID: 'lx-online-booking-calendar-multi',
            };
        },
    };
</script>
